import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component( {
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    constructor( ) {
      // TODO
    }

    public ngOnInit() {
      // TODO
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/app.component.ts